import { IconButton } from '@mui/material';
import { Close as IconClose } from '@mui/icons-material';
import { useSnackbar } from 'notistack';

interface SnackbarCloseButtonProps {
    id: any
}

const SnackbarCloseButton:React.FC<SnackbarCloseButtonProps> = ({ id }) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton onClick={() => closeSnackbar(id)}>
      <IconClose />
    </IconButton>
  );
}

export default SnackbarCloseButton;